import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {size2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            shape: z
                .object({
                    numPatches: vector2Like.optional(), // default: computed from image size and patch size
                    patchSize: size2Like,
                })
                .or(
                    z.object({
                        numPatches: vector2Like,
                        patchSize: size2Like.optional(), // default: computed from image size and number of patches
                    }),
                ),
            options: z
                .object({
                    allowPatchFill: z.boolean().optional(), // default: false; allow for size to be not a multiple of patch size, filling the remaining pixels with the address mode provided
                })
                .optional(),
        }),
    },
}
